__turbopack_context__.v({
  "dynamicHeader": "StoreHeader-module-scss-module__yltZgq__dynamicHeader",
});
